import { FaCar, FaUsers, FaWarehouse, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaCar />, // Car icon for cars sold
        title: 'Cars Sold',
        count: '5000',
    },
    {
        id: 2,
        icon: <FaUsers />, // Users icon for happy customers
        title: 'Happy Customers',
        count: '4500',
    },
    {
        id: 3,
        icon: <FaWarehouse />, // Warehouse icon for available cars
        title: 'Available Cars',
        count: '300',
    },
    {
        id: 4,
        icon: <FaMapMarkerAlt />, // Location marker icon for locations served
        title: 'Locations Served',
        count: '50',
    },
];

export default counter; 